import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getShowsDestacados } from '../../../../http/Actions/VideoShowAction';
import { FaClock, FaCalendarAlt, FaEye } from 'react-icons/fa';

const SugeridosDestacados = ({ currentVideoId, isMobile = false }) => {
  const [suggestedShows, setSuggestedShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    
    const successCallback = (response) => {
      if (response && response.status === 200 && Array.isArray(response.data)) {
        // Filtramos el video actual y ordenamos por fecha
        const filteredShows = response.data
          .filter(show => show.videoShowId !== currentVideoId)
          .sort((a, b) => new Date(b.fechaEstreno) - new Date(a.fechaEstreno));
        
        setSuggestedShows(filteredShows);
        setLoading(false);
      } else {
        console.error("Formato de respuesta inesperado:", response);
        setError("Formato de respuesta inesperado");
        setLoading(false);
      }
    };
    
    const errorCallback = (err) => {
      console.error("Error obtenido:", err);
      setError(err || "Error al cargar los shows sugeridos");
      setLoading(false);
    };
    
    getShowsDestacados(successCallback, errorCallback, token);
  }, [currentVideoId]);

  const handleVideoClick = (videoId) => {
    navigate(`/contenido/ver/${videoId}`);
  };

  // Función para truncar texto si es demasiado largo
  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };
  
  // Formatea números (para vistas)
  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num;
  };
  
  if (loading) {
    return (
      <div className="w-full">
        <h2 className="text-xl font-bold text-white mb-4">
          Próximos videos
        </h2>
        <div className="space-y-3">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="bg-gray-800/50 rounded-lg p-2 animate-pulse flex gap-2">
              <div className="w-40 h-20 bg-gray-700 rounded-lg flex-shrink-0"></div>
              <div className="flex-1">
                <div className="h-4 bg-gray-700 rounded w-3/4 mb-2"></div>
                <div className="h-3 bg-gray-700 rounded w-1/2 mb-2"></div>
                <div className="h-3 bg-gray-700 rounded w-1/4"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full bg-red-900/30 p-4 rounded-lg border border-red-700">
        <p className="text-white">Error al cargar videos sugeridos: {error}</p>
      </div>
    );
  }

  if (suggestedShows.length === 0) {
    return null;
  }

  return (
    <div className="w-full">
      <h2 className="text-xl font-bold text-white mb-3">
        Más videos como este
      </h2>
      
      <div className="space-y-3">
        {suggestedShows.map((show) => (
          <div 
            key={show.videoShowId} 
            className="group rounded-lg overflow-hidden hover:bg-gray-800/70 transition-all duration-200 cursor-pointer flex gap-2"
            onClick={() => handleVideoClick(show.videoShowId)}
          >
            {/* Thumbnail con duración - Estilo YouTube */}
            <div className="relative w-40 h-20 flex-shrink-0">
              <img 
                src={show.imagen} 
                alt={show.titulo} 
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute bottom-1 right-1 bg-black/80 px-1 py-0.5 rounded text-[10px]">
                {show.duracion} min
              </div>
            </div>
            
            {/* Información del video - Estilo YouTube */}
            <div className="flex-1 py-1">
              <h3 className="font-medium text-sm text-white mb-1 line-clamp-2 group-hover:text-purple-300">
                {truncateText(show.titulo, 60)}
              </h3>
              
              {/* Comediantes */}
              {show.comediantes?.length > 0 && (
                <p className="text-gray-400 text-xs mb-1">{show.comediantes.join(', ')}</p>
              )}
              
              {/* Info adicional */}
              <div className="flex items-center text-[10px] text-gray-400">
                <div className="flex items-center">
                  <FaEye className="mr-1" size={10} />
                  <span>{formatNumber(show.vistas || 0)} visualizaciones</span>
                </div>
                <span className="mx-1">•</span>
                <span>
                  {new Date(show.fechaEstreno).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SugeridosDestacados;